module.exports = __webpack_public_path__ + "img/delete-white.36ed3728.svg";